export const NotifiedRight = (props) => {
  const { size = 80, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 80 80'>
        <circle opacity='0.4' cx='40' cy='40' r='40' fill='#FFB47B' />
        <path
          d='M29.4998 40.0001L36.4998 47.0001L50.4998 33.0001M63.3332 40.0001C63.3332 52.8867 52.8865 63.3334 39.9998 63.3334C27.1132 63.3334 16.6665 52.8867 16.6665 40.0001C16.6665 27.1134 27.1132 16.6667 39.9998 16.6667C52.8865 16.6667 63.3332 27.1134 63.3332 40.0001Z'
          stroke='currentcolor'
          strokeWidth='4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};
